import React from "react";
import TestemonialCard from "../TestimonialCard";
import testimonials from "../../../assets/data/testemonials";

const Testemonials = () => {
  return (
    <section className="md:py-94px py-64px">
      <div className="m-auto max-w-[1560px] md:px-30px px-20px flex md:gap-32px gap-20px relative overflow-hidden w-fit max-h-[600px] before:absolute before:bottom-[-10px] before:left-0 before:w-full before:h-[250px] before:z-10 before:bg-gradient-to-b from-transparent to-white dark:to-accent-900">
        <div className="flex flex-col md:gap-32px gap-20px w-full ">
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[0].message}
              name={testimonials[0].name}
              badge={testimonials[0].badge}
            />
            <TestemonialCard
              message={testimonials[1].message}
              name={testimonials[1].name}
              badge={testimonials[1].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[0].message}
              name={testimonials[0].name}
              badge={testimonials[0].badge}
            />
            <TestemonialCard
              message={testimonials[1].message}
              name={testimonials[1].name}
              badge={testimonials[1].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[0].message}
              name={testimonials[0].name}
              badge={testimonials[0].badge}
            />
            <TestemonialCard
              message={testimonials[1].message}
              name={testimonials[1].name}
              badge={testimonials[1].badge}
            />
          </div>
        </div>
        <div className="sm:flex flex-col md:gap-32px gap-20px w-full hidden">
          <div
            style={{ animation: "30s slideBottom infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[2].message}
              name={testimonials[2].name}
              badge={testimonials[2].badge}
            />
            <TestemonialCard
              message={testimonials[3].message}
              name={testimonials[3].name}
              badge={testimonials[3].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideBottom infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[2].message}
              name={testimonials[2].name}
              badge={testimonials[2].badge}
            />
            <TestemonialCard
              message={testimonials[3].message}
              name={testimonials[3].name}
              badge={testimonials[3].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideBottom infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[2].message}
              name={testimonials[2].name}
              badge={testimonials[2].badge}
            />
            <TestemonialCard
              message={testimonials[3].message}
              name={testimonials[3].name}
              badge={testimonials[3].badge}
            />
          </div>
        </div>
        <div className="lg:flex flex-col md:gap-32px gap-20px w-full hidden">
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[4].message}
              name={testimonials[4].name}
              badge={testimonials[4].badge}
            />
            <TestemonialCard
              message={testimonials[5].message}
              name={testimonials[5].name}
              badge={testimonials[5].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[4].message}
              name={testimonials[4].name}
              badge={testimonials[4].badge}
            />
            <TestemonialCard
              message={testimonials[5].message}
              name={testimonials[5].name}
              badge={testimonials[5].badge}
            />
          </div>
          <div
            style={{ animation: "30s slideTop infinite linear" }}
            className="flex flex-col gap-32px"
          >
            <TestemonialCard
              message={testimonials[4].message}
              name={testimonials[4].name}
              badge={testimonials[4].badge}
            />
            <TestemonialCard
              message={testimonials[5].message}
              name={testimonials[5].name}
              badge={testimonials[5].badge}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testemonials;
